import {
  INTAKE_SUMMARY_SOURCE,
  PreVisitSummaryCardConnected,
  ProviderEventType,
  toIntakeFormReviewSource,
  useSetCoachConversation,
} from '@grow-therapy-team/seedling-components';

import { AppointmentType } from '../../schedule-preview/types';
import { IntakeSummaryConnectedWithFormsPrefetch } from '../IntakeSummaryConnectedWithFormsPrefetch';
import { useOpenIntakeFormResponseCallback } from '../useOpenIntakeFormResponseCallback';
import { usePreVisitSummaryCardWrapper } from './usePreVisitSummaryCardWrapper';

export function PreVisitSummaryCardWrapper() {
  const {
    appointmentShortId,
    patientShortId,
    appointmentType,
    nudgeContext,
    preVisitSummaryCardComponent,
    resourceButtonOnClickHandlers,
  } = usePreVisitSummaryCardWrapper();

  const { setCoachConversation } = useSetCoachConversation();
  const openIntakeFormResponse = useOpenIntakeFormResponseCallback();

  if (!appointmentShortId || !patientShortId) {
    return null;
  }

  const isIntakeAppointment = appointmentType === AppointmentType.Intake;

  return (
    <PreVisitSummaryCardConnected
      appointmentShortId={appointmentShortId}
      patientShortId={patientShortId}
      providerViewEventType={ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_TELEHEALTH}
      includeTitle
      clinicalRiskNudgeEnhancementsContext={nudgeContext}
      nudgeContext={nudgeContext}
      preVisitSummaryCardComponent={preVisitSummaryCardComponent}
      onClickUnreadCoachConversation={setCoachConversation}
      resourceButtonOnClickHandlers={resourceButtonOnClickHandlers}
      betweenNudgesAndContent={
        isIntakeAppointment ? (
          <IntakeSummaryConnectedWithFormsPrefetch
            patientShortId={patientShortId}
            appointmentShortId={appointmentShortId}
            showViewFullIntakeButton
            source={INTAKE_SUMMARY_SOURCE.TELEHEALTH_CLIENT_INFO_DRAWER}
            isInverse
            onViewFullIntake={() => {
              void openIntakeFormResponse({
                patientShortId,
                source: toIntakeFormReviewSource(INTAKE_SUMMARY_SOURCE.TELEHEALTH_CLIENT_INFO_DRAWER),
              });
            }}
          />
        ) : undefined
      }
      isInverse
    />
  );
}
